<template>
  <div class="drawer-title py-2 px-3 get-height">
    <v-layout align-center justify-start row>
      <v-btn
        v-if="history.length > 1"
        color="gray-6"
        class="ml-0"
        icon
        flat
        @click="goBack"
      >
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">
        {{ action === 'preview' ? $t(`${namespace}.title`) : $t(`${namespace}.editProject`) }}
      </v-flex>
    </v-layout>

    <div>
      <v-menu
        v-if="
          action === 'preview' &&
          (claims.project['ROLE_PUT_PROJECT_ID'] || claims.project['ROLE_DELETE_PROJECT_ID'])
        "
        offset-y
        left
      >
        <v-btn class="btn--more_vertical mx-0" color="gray-6" slot="activator" flat icon>
          <v-icon>more_vertical</v-icon>
        </v-btn>

        <v-list class="dropdown-menu-actions__list">
          <v-list-tile
            v-if="claims.project['ROLE_PUT_PROJECT_ID']"
            @click="handleEditProject"
          >
            <v-list-tile-title>
              {{ $t('Common.editProject') }}
            </v-list-tile-title>
          </v-list-tile>

          <v-divider v-if="claims.project['ROLE_PUT_PROJECT_ID'] && claims.project['ROLE_DELETE_PROJECT_ID']" />

          <v-list-tile
            v-if="claims.project['ROLE_DELETE_PROJECT_ID']"
            @click="openSingleDeleteDialog"
          >
            <v-list-tile-title>{{ $t('Common.deleteProject') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-btn
        color="gray-6"
        class="mx-0"
        icon
        flat
        @click="close()"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </div>

    <SingleDeleteDialog
      :visible="singleDeleteDialog"
      :item="data"
      @close="closeSingleDeleteDialog"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SingleDeleteDialog from 'components/projects/dialogs/SingleDeleteDialog'

export default {
  name: 'Header',
  props: {
    history: {
      type: Array,
      default: () => []
    },

    data: {
      type: Object,
      required: true
    },

    action: {
      type: String,
      required: true
    }
  },
  components: {
    SingleDeleteDialog
  },
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.project.header',
      singleDeleteDialog: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    goBack () {
      this.$emit('goBack')
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    handleEditProject () {
      this.$emit('toggleAction', 'edit')
    },

    openSingleDeleteDialog () {
      this.singleDeleteDialog = true
    },

    closeSingleDeleteDialog (reload) {
      this.singleDeleteDialog = false
      reload && this.close(reload)
    }
  }
}
</script>
